// ページパーツ「カート追加ボタン」
// オプション・サイズ・カラーを選択して、カートに追加する

import { ItemOptionSelectForm_withOptions } from '@/app/ui/parts/default/sp/item/itemOptionSelectFormV2'
import { itemOptionType, itemType } from '@/lib/item/server'
import { serviceType } from '@/lib/service/server'
import { Soldout } from '../item/soldout'

export const AddCartForm = ({
  service,
  item,
  itemOptions,
}: {
  service: serviceType
  item: itemType
  itemOptions: itemOptionType[]
}) => {
  if (
    !item.stock ||
    itemOptions.filter((opt) => opt.stock === true).length === 0
  ) {
    return <Soldout />
  }
  return (
    <div className="add-cart-form space-y-4 m-4">
      <ItemOptionSelectForm_withOptions
        service={service}
        item={item}
        itemOptions={itemOptions.filter((opt) => opt.stock === true)}
        promotionModal={false}
      />
    </div>
  )
}
